import { Injectable, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Address } from '../../models/UIModels/Address';
import { AdditionalFile } from '../../models/UIModels/AdditionalFile';

@Injectable({
  providedIn: 'root'
})
export class ChildFormsService {

  public PersonInfoForm:FormGroup;

  public AppsToBeUsedForm:FormGroup;

  public LogoSignatureForm:FormGroup;

  public GeneralInfoForm:FormGroup;

  public TaxPayerDetailForm:FormGroup;

  public NotificationSettingsForm:FormGroup;

  public AdressList:Array<Address>;

  public OtherInfoForm:FormGroup;

  public AdditionalDocs:Array<AdditionalFile>;

  public VknTcknForm:FormGroup;

  public PreviewClosed:EventEmitter<any> = new EventEmitter<any>()

  public SalesForm:FormGroup

  constructor() {
    this.AdressList = new Array<Address>();
    this.AdditionalDocs = new Array<AdditionalFile>();
   }

}
